import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../shared/Button';

const DeleteReservationSeries = ({
  open,
  reservationId,
  reservationSeriesId,
  onClose,
  onDeleteSeries,
  onDeleteDay,
  translate,
}) => (
  <Dialog fullWidth open={open} onClose={onClose} disableBackdropClick className="WarnMessage">
    <DialogTitle className="WarnMessage-header" disableTypography>
      <DialogActions>
        <button type="button" className="WarnMessage-closeButton" onClick={onClose}>
          &times;
        </button>
      </DialogActions>
      {translate('reservationSeries.deleteHeader')}
    </DialogTitle>
    <DialogContent className="WarnMessage-content">
      <DialogContentText className="WarnMessage-message">
        {translate('reservationSeries.deleteMessage1')}
      </DialogContentText>
      <DialogContentText className="WarnMessage-message">
        {translate('reservationSeries.deleteMessage2')}
      </DialogContentText>
    </DialogContent>
    <DialogActions className="Space-between">
      <Button
        handleClick={() => {
          onDeleteDay(reservationId);
          onClose();
        }}
      >
        {translate('reservationSeries.deleteReservation')}
      </Button>
      <div>
        <Button handleClick={onClose}>{translate('reservation.cancel')}</Button>
        <Button
          handleClick={() => {
            onDeleteSeries(reservationSeriesId);
            onClose();
          }}
          active
          long
          style={{ marginLeft: '10px' }}
        >
          {translate('reservationSeries.deleteReservationSeries')}
        </Button>
      </div>
    </DialogActions>
  </Dialog>
);

DeleteReservationSeries.propTypes = {
  open: PropTypes.bool,
  reservationId: PropTypes.number,
  reservationSeriesId: PropTypes.number,
  onClose: PropTypes.func,
  onDeleteSeries: PropTypes.func,
  onDeleteDay: PropTypes.func,
  translate: PropTypes.func,
};

DeleteReservationSeries.defaultProps = {
  open: false,
  reservationId: undefined,
  reservationSeriesId: undefined,
  onClose: () => {},
  onDeleteSeries: () => {},
  onDeleteDay: () => {},
  translate: () => {},
};

export default DeleteReservationSeries;
